import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import News from './pages/News';
import NewsArticle from './pages/NewsArticle';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Admin from './pages/Admin';
import LegalPage from './pages/LegalPage';

function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-[#0B1B3D] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) return <Navigate to="/bejelentkezes" replace />;
  if (adminOnly && user.role !== 'admin') return <Navigate to="/portal" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Layout><Home /></Layout>} />
      <Route path="/rolunk" element={<Layout><About /></Layout>} />
      <Route path="/szolgaltatasok" element={<Layout><Services /></Layout>} />
      <Route path="/hirek" element={<Layout><News /></Layout>} />
      <Route path="/hirek/:slug" element={<Layout><NewsArticle /></Layout>} />
      <Route path="/kapcsolat" element={<Layout><Contact /></Layout>} />
      <Route path="/bejelentkezes" element={<Layout><Login /></Layout>} />
      <Route path="/jogi/:slug" element={<Layout><LegalPage /></Layout>} />
      <Route
        path="/portal"
        element={
          <ProtectedRoute>
            <Layout><Dashboard /></Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <ProtectedRoute adminOnly>
            <Admin />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
